// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import axios from 'axios';
import qs from 'qs';

Vue.config.productionTip = false
// console.log('VUE_APP_ENV:', process.env)
window.owl('config', {
  devMode: process.env.NODE_ENV !== 'production'
})
/* eslint-disable no-new */
Vue.use(ElementUI);
Vue.use(VueJsonPretty)
Vue.prototype.$http = axios
Vue.prototype.$qs = qs

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})
